import React, { useMemo, useState } from "react";
import styles from "../../assets/styles/InvoiceReceipt/InvoiceReceipt.module.scss";
import {
  AppPage,
  MimaFilter,
  Searchbar,
  BusinessInsightComponent as BIC,
  PageLoader,
  MimaTable,
  MimaButton,
} from "../../components";
import { AnimatePresence } from "framer-motion";
import ViewMoreContainer from "../../containers/InvoiceReceiptContainer/ViewMoreContainer";
import moment from "moment";
import { amountFormatter } from "../../utils/utils";
import { data } from "autoprefixer";
import constant from "../../utils/constant";
import { downloadXlsx2 } from "../../utils/download";

const InvoiceReceipt = ({
  business,
  viewMoreModal,
  handleViewMore,
  closeModal,
  allInvoices,
  allInvoicesAnalysis,
  data,
  loading,
  isLoading,
  isFetching,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
}) => {
  const invoiceStatus = allInvoicesAnalysis?.statuses;
  const [curr, setCurr] = useState("NGN");

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.value.invoices || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date Created",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original?.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "customer Name",
      Cell: ({ cell }) => {
        const customer = cell.row.original?.customer.fullname;
        return <span>{customer}</span>;
      },
    },
    {
      Header: "Amount",
      accessor: "transactionAmount",
      Cell: ({ cell }) => {
        const amount = cell.row.original?.transactionAmount;
        const currencyCode = cell.row.original.currencyCode;
        return <span>{amountFormatter(currencyCode).format(amount)}</span>;
      },
    },
    {
      Header: "Due Date",
      accessor: "dueDate",
      Cell: ({ cell }) => {
        const dueDate = cell.row.original?.dueDate;
        return <span>{moment(dueDate).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.row.original?.status;
        const styleClass = `status ${status === "FULLY-PAID" ? "status__green" : status === "UNPAID" ? "status__red" : status === "VOID" ? "status__grey" : "status__dark__yellow"}`;
        return <span className={styleClass}>{status}</span>;
      },
    },
    {
      Header: "Action",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <span
            className="tableAction__text"
            onClick={() => {
              handleViewMore(item);
            }}
          >
            View More
          </span>
        );
      },
    },
  ];

  const printData = tableData.map((item) => ({
    "Date Created":
      `${moment(item.createdAt).format("DD/MM/YYYY HH:mm a")}` || "",
    "Customer Name": item.customer?.fullname || "",
    Amount:
      `${amountFormatter(item.currencyCode).format(item.transactionAmount)}` ||
      "",
    "Due Date": `${moment(item.dueDate).format("DD/MM/YYYY HH:mm a")}` || "",
    Status: item.status || "",
  }));

  return (
    <AppPage pageTitle={`${business.tradingName} Invoices/Receipts`}>
      {loading ? (
        <PageLoader title="while we set things up for you" />
      ) : (
        <>
          {/* <div className={styles.main_nav}>
            {invoiceStatus?.map((item) => (
              <div
                key={item._id}
                className={
                  curr === item._id
                    ? styles.main_nav_item_active
                    : styles.main_nav_item
                }
                onClick={() => {
                  setCurr(item._id);
                }}
              >
                {item._id} Invoice Insight
              </div>
            ))}
          </div>
          <div className={styles.upper__metrics}>
            <BIC
              info="Total Number of Invoices created"
              title="Invoices Created"
              amount={allInvoices.length}
              styleClass={styles.upper__metrics_invoicesCreated}
            />

            {invoiceStatus
              ?.filter((x) => {
                return x._id === curr;
              })[0]
              ?.status?.map((y, i) => {
                return (
                  <BIC
                    info={
                      y.type === "PARTIALLY-PAID"
                        ? "Total Amount of partially paid invoices"
                        : y.type === "FULLY-PAID"
                          ? "Total Amount of fully paid invoices"
                          : y.type === "UNPAID"
                            ? "Total Amount of unpaid invoices"
                            : "Total Amount of cancelled Invoices"
                    }
                    title={`${y.type} Invoices`}
                    amount={amountFormatter(curr).format(y.totalAmount)}
                    styleClass={
                      y.type === "PARTIALLY-PAID"
                        ? styles.upper__metrics_partiallyPaidInvoices
                        : y.type === "FULLY-PAID"
                          ? styles.upper__metrics_fullyPaidInvoices
                          : y.type === "UNPAID"
                            ? styles.upper__metrics_unpaidInvoices
                            : styles.upper__metrics_overdueInvoices
                    }
                    key={i}
                  />
                );
              })}

            <BIC
              info="Total Number of Receipts created"
              title="Receipts Created"
              amount={
                allInvoices.filter((x) => {
                  return (
                    x.status === "FULLY-PAID" || x.status === "PARTIALLY-PAID"
                  );
                }).length
              }
              styleClass={styles.upper__metrics_receiptsCreated}
            />
          </div> */}

          <MimaButton
            title={`Download Invoice/Receipt Report`}
            onClick={() => {
              downloadXlsx2(printData, "Invoice/Receipt Report");
            }}
            mt={4}
            mb={4}
          />

          <MimaTable
            tableData={tableData}
            tableColumns={tableColumns}
            searchPlaceholder="Search Invoices"
            searchVariant="wide"
            totalItems={data?.data?.totalCounts}
            onLimitChange={onLimitChange}
            isLoading={isLoading}
            isFetching={isFetching}
            limit={limit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSearchQuery={setSearchQuery}
          />
        </>
      )}

      {viewMoreModal && (
        <AnimatePresence>
          <div className="modal">
            {viewMoreModal && <ViewMoreContainer closeModal={closeModal} />}
          </div>
        </AnimatePresence>
      )}
    </AppPage>
  );
};
export default InvoiceReceipt;
